const grades = { 
  grade_aplus: 'Grade A+',
  grade_a: 'Grade A',
  grade_bplus: 'Grade B+',
  grade_b: 'Grade B',
  grade_c: 'Grade C'
}

export default (grade = '') => grades[grade]